import React from "react";
import SEO from '../services/SEO';
import { useTranslation } from "react-i18next";
import TLSAnaliseCombinacoes from "../components/TLSAnaliseCombinacoes/TLSAnaliseCombinacoes";

const AnalisCombin= () => {

	window.scrollTo(0, 0);
	const { t, i18n: {changeLanguage, language} } = useTranslation();

	return(
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">{t("analise_padroes")}</h2>
			<br/>
			<hr/>
			<br/>
			<TLSAnaliseCombinacoes/>
		</div>
	);
}

export default AnalisCombin;